import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadFinishForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<HeadFinishForSaveDto>;

export const TABLE = 'putterHeadFinish';
const SCHEMA = 'headFinishId, sortId';

class PutterHeadFinishDatabase implements DataRepository<HeadFinishForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<HeadFinishForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadFinishForSaveDto, key: Key): Promise<HeadFinishForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: HeadFinishForSaveDto[]): Promise<HeadFinishForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadFinishForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterHeadFinishDB = new PutterHeadFinishDatabase(db);
